import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { IonIcon } from "@ionic/vue";
import { addOutline, closeOutline } from "ionicons/icons";
import { ref } from "vue";
import { useI18n } from "vue-i18n";


export default /*#__PURE__*/_defineComponent({
  __name: 'CreatePropertyButton',
  props: {
  organisationPrefix: {
    type: String,
    default: "",
  },
  canCreateSurvey: {
    type: Boolean,
    default: false,
  },
  isMobile: {
    type: Boolean,
    default: false,
  },
},
  emits: ["createSurvey", "createObject", "extended"],
  setup(__props, { emit }) {

const props = __props;

const { t } = useI18n();




const extended = ref(false);
const mainIcon = ref(addOutline);

const toggleExtended = () => {
    extended.value = !extended.value;
    if( extended.value) {
        mainIcon.value = closeOutline;        
    } else {
        mainIcon.value = addOutline;
    }
    emit('extended', extended.value);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["flex flex-col items-stretch absolute right-3 z-10", {'bottom-3': !__props.isMobile, 'mobile-button': __props.isMobile && !extended.value, 'mobile-button-extended': __props.isMobile && extended.value}])
  }, [
    _withDirectives(_createElementVNode("div", {
      class: "flex flex-row justify-end sub-button mb-2",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('createSurvey')))
    }, [
      _withDirectives(_createElementVNode("div", { class: "sub-label" }, _toDisplayString(_unref(t)(`${__props.organisationPrefix}toolbar.mobile.surveyDetail`)), 513), [
        [_vShow, extended.value && __props.canCreateSurvey]
      ]),
      _createVNode(_unref(IonIcon), {
        slot: "icon-only",
        icon: _unref(addOutline),
        class: "sub-icon"
      }, null, 8, ["icon"])
    ], 512), [
      [_vShow, extended.value]
    ]),
    _withDirectives(_createElementVNode("div", {
      class: "flex flex-row justify-end sub-button mb-2",
      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('createObject')))
    }, [
      _withDirectives(_createElementVNode("div", { class: "sub-label" }, _toDisplayString(_unref(t)(`${__props.organisationPrefix}toolbar.mobile.objectDetail`)), 513), [
        [_vShow, extended.value]
      ]),
      _createVNode(_unref(IonIcon), {
        slot: "icon-only",
        icon: _unref(addOutline),
        class: "sub-icon"
      }, null, 8, ["icon"])
    ], 512), [
      [_vShow, extended.value]
    ]),
    _createVNode(_unref(IonIcon), {
      slot: "icon-only",
      class: _normalizeClass(["cpb self-end", __props.isMobile ? 'cpb-size-mobile' : 'cpb-size']),
      icon: mainIcon.value,
      onClick: toggleExtended
    }, null, 8, ["class", "icon"])
  ], 2))
}
}

})